module.exports = __webpack_public_path__ + "static/media/ra-logo.89b5ced2.svg";